export default "/assets/images/unit-slide1.webp?6fedb203907b04abb012c6bb3b503922";